<div class="details">
  <div class="body">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      @if (ratingScaleLevel) {
        <div
          class="severity"
        [ngStyle]="{
          'background-color': ratingScaleLevel.htmlColorCode,
          'color': ratingScaleLevel.textColor
        }">
          {{ ratingScaleLevel.label }}
        </div>
      }
      <div class="menu">
        <topo-action-menu
          [appendToBody]="true"
          location="right"
          size="normal">
          <topo-action
            label="{{ 'COMMUNICATIONS.BUTTONS.EXCEPTION-LOG' | translate }}"
            icon="icon-history"
          (actionClick)="logClick()"></topo-action>
        </topo-action-menu>
      </div>
    </div>
    <div class="main-name">
      {{ notification?.name }}
    </div>
    <topo-workflow-gen-transition-select
      [hostObject]="notification"
      [workflow]="notificationWorkflow"
      [hideSingleWorkflow]="false"
      [isEdit]="false"
    (stepChanged)="onWorkflowStepChanged($event)"></topo-workflow-gen-transition-select>
  </div>
  <div class="separator"></div>
  <div class="content-body">
    <div class="field">
      <label>{{ 'COMMUNICATIONS.COLUMNS.UPDATED-ON' | translate }}</label>
      {{ getDateDisplay(notification?.updatedOn) }}
    </div>
    <div class="field">
      <label>{{ 'COMMUNICATIONS.COLUMNS.UPDATED-BY' | translate }}</label>
      {{ notification?.lastEditedByName }}
    </div>
    <div class="field">
      <label>{{ 'COMMUNICATIONS.NOTIFICATION-TEMPLATE' | translate }}</label>
      {{ notificationTemplate?.name }}
    </div>
    @if (notificationTemplate?.type) {
      <div
        class="field"
        >
        <label>{{ 'COMMUNICATIONS.MASS-NOTIFICATION-TEMPLATE-TYPE' | translate }}</label>
        {{ 'COMMUNICATIONS.NOTIFICATION-TYPE-' + notificationTemplate?.type | translate }}
      </div>
    }
    @if (hasBusinessUnits) {
      <div
        class="field"
        >
        <label>{{ 'COMMUNICATIONS.BUSINESS-UNITS' | translate }}</label>
        <div
          class="business-units"
          [ngClass]="{ 'disabled': !(businessUnits?.length > 0) }">
          <topo-business-unit-select
            [multiSelectionMode]="true"
            [readonly]="true"
            [selectedUIds]="selectedUnitUIds"
          [businessUnits]="businessUnits"></topo-business-unit-select>
        </div>
      </div>
    }

    <div class="field">
      <label>{{ 'COMMUNICATIONS.NOTIFICATION-WORKFLOW-TEMPLATE' | translate }}</label>
      {{ notificationWorkflow?.name }}
    </div>
    <div class="field">
      <label>{{ 'COMMUNICATIONS.RECIPIENT-WORKFLOW-TEMPLATE' | translate }}</label>
      {{ recipientWorkflow?.name }}
    </div>
    <div class="channels">
      <topo-template-channels-selection
        [readonlyMode]="true"
        [summaryMode]="true"
        [responseRequired]="isSafetyCheckType()"
      [channelsCascadeSettings]="notification?.channelsCascadeSettings"></topo-template-channels-selection>
    </div>
  </div>
</div>

<topo-comms-notification-log
  [notification]="logNotification"
(logClosed)="onLogClosed()"></topo-comms-notification-log>
